import { render, staticRenderFns } from "./RejectedPackageInstructions.vue?vue&type=template&id=08afa707&scoped=true"
import script from "./RejectedPackageInstructions.vue?vue&type=script&lang=ts"
export * from "./RejectedPackageInstructions.vue?vue&type=script&lang=ts"
import style0 from "./RejectedPackageInstructions.vue?vue&type=style&index=0&id=08afa707&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08afa707",
  null
  
)

export default component.exports